import * as sharingActions from '../../../sharing/actions';

import React from 'react';
import { AddCircle, MinusCirlce } from '@myua/icons/dist/bulk24';
import { useDispatch, useSelector } from 'react-redux';
import { getShareSelectedNodes } from '../../../sharing/selectors';
import { FileManagerRow } from '../../model';
import { CheckboxProps } from '../../../../../general/components/Checkbox/Checkbox';
import { isNodeDownloadAllowed } from '../../../../../general/node';
import { WithTooltipPopup } from '../../../../../general/components/WithTooltipPopup/WithTooltipPopup';

const Component: React.FC<CheckboxProps & { disabled?: boolean }> = ({
  isChecked,
  onChange,
  disabled,
}) => {
  return (
    <div
      className={`ch-share-selector-icon ch-share-selector-icon_selected-${isChecked}${
        disabled ? ' ch-share-selector-icon_disabled' : ''
      }`}
      onClick={(e) => {
        if (disabled) return;
        onChange(!isChecked, e.shiftKey);
      }}
    >
      {isChecked ? <MinusCirlce /> : <AddCircle />}
    </div>
  );
};

const Connected: React.FC<{ rowData: FileManagerRow }> = ({ rowData }) => {
  const isChecked =
    useSelector(getShareSelectedNodes).find((node) => node.id === rowData.id) !== undefined;
  const dispatch = useDispatch();

  // Файл под модерацией шарить нельзя: чекбокс задизейблен с пояснением (MYUA-16456).
  const disabled = !isNodeDownloadAllowed(rowData);

  const cell = (
    <Component
      isChecked={isChecked}
      disabled={disabled}
      onChange={(checked, shift) =>
        dispatch(
          sharingActions.shareSelectorChanged({
            node: rowData,
            isChecked: checked,
            shift,
          }),
        )
      }
    />
  );

  return disabled ? (
    <WithTooltipPopup text="This file is unavailable for sharing" trigger={cell} />
  ) : (
    cell
  );
};

export const ShareSelectorCell = (props: { rowData: FileManagerRow }) => <Connected {...props} />;
